module.exports = __webpack_public_path__ + "img/us_army_logo.e700f2f0.svg";